import { makeRequest } from '@/base/MaRequestPooler.js'

export function addCredential(storeName, data) {
  return makeRequest(`/account/store-account/${storeName}`, {
    method: 'POST',
    data,
  })
}

export function getIosAccounts(data) {
  return makeRequest(`/account/store-account/ios/possible-providers`, {
    method: 'POST',
    data: { payload: data },
  })
}

export function sendAccountsToIntegration({ connectAccessToken, providerIds }) {
  return makeRequest(`/account/store-account/ios-shared`, {
    method: 'POST',
    data: {
      connectAccessToken,
      providerIds,
    },
  })
}
